<button
    type="button"
    mat-icon-button
    [class]="[color, size]"
    [disabled]="disabled"
    [attr.data-uiid]="dataUiid"
    [matTooltip]="tooltipContent ?? ''"
>
    <ng-content></ng-content>
</button>
